import React, { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import FetchValueFormInput from '../FetchValueFormInput';

const CompoundDisabledInput = ({ name, references, query, props }) => {
    const [inputProps, setInputProps] = useState(props);
    const [refresh, setRefresh] = useState(false);
    const { watch, getValues } = useFormContext();

    useEffect(() => {
        const [value] = getValues([...references]);
        setInputProps((prev) => ({ ...prev, disabled: !Boolean(value) }));
        setRefresh(!Boolean(value));
    }, [...watch([...references])]);

    return <FetchValueFormInput name={name} query={query} props={inputProps} refresh={refresh} />;
};

export default CompoundDisabledInput;
